type FreshnessLabel = 'Last seen' | 'Last checked' | 'Last synced';
export type RecordFreshness = { label: FreshnessLabel; value: string } | null;

export function recordFreshness(record: any): RecordFreshness {
  const candidates: Array<[FreshnessLabel, unknown]> = [
    ['Last seen', record?.last_seen_at ?? record?.last_seen ?? record?.last_heartbeat_at ?? record?.last_heartbeat],
    ['Last checked', record?.last_checked_at ?? record?.status_checked_at ?? record?.health_checked_at],
    ['Last synced', record?.last_synced_at ?? record?.last_synced ?? record?.synced_at],
  ];
  const match = candidates.find(([, value]) => typeof value === 'string' && value.length > 0);
  return match ? { label: match[0], value: match[1] as string } : null;
}
